import { useCanUploadFile } from '#pplx/frontend/apps/ask/hooks/file-attachments-hooks/useCanUploadFile.js';
import { useCallback, useMemo } from 'react';
export function useGateUploadFile({ uploadRateLimit, }) {
    const canUploadFileCallback = useCanUploadFile({ uploadRateLimit });
    const canUploadFile = useMemo(() => canUploadFileCallback(), [canUploadFileCallback]);
    const checkUploadFile = useCallback(() => canUploadFileCallback(), [canUploadFileCallback]);
    return useMemo(() => ({ checkUploadFile, canUploadFile }), [canUploadFile, checkUploadFile]);
}
//# sourceMappingURL=useGateUploadFile.js.map